import { taxLocations } from '../../CommonUtils/taxLocations';
import { isNumeric } from '../../../js/app/react/validators';

const MARRIED_JOINTLY = 2;

export const validateAndStoreTaxesLocation = (
  taxesLocation,
  hasPartner,
  storeLocation,
  storeStatus,
) => () => {
  const errors = [];
  const taxLocationID = (taxLocations.find(state => state.value === taxesLocation) || {}).taxID;

  if (!isNumeric(taxLocationID)) {
    errors.push('Please select a valid state');
  } else {
    storeLocation({
      target: {
        value: taxLocationID,
      },
    });
    if (hasPartner) {
      storeStatus({
        target: {
          value: MARRIED_JOINTLY,
        },
      });
    }
  }
  return errors;
};

export default null;
